import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { style: {"display":"flex","justify-content":"flex-end"} }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("新增")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("导出")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("% ")
const _hoisted_5 = { class: "dialog-footer" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" 确认 ")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("启用")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("停用")
const _hoisted_10 = /*#__PURE__*/_createTextVNode("编辑")
const _hoisted_11 = { style: {"display":"flex","justify-content":"flex-end"} }

import stubs from '@/init';
import { computed, reactive, getCurrentInstance } from 'vue';
import { ElMessage } from 'element-plus';
import KriMetricsController from './controller/KriMetrics.Controller';

import {
  KriMetricsSettingSearchVO,
  KriMetricsSettingVO,
  RiskRatingSettingObj,
} from './vo';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const { proxy } = getCurrentInstance() as any;
const controller: KriMetricsController =
  stubs.injector.get(KriMetricsController);
const state = reactive({
  editItem: {} as KriMetricsSettingVO,
  data: [] as Array<KriMetricsSettingVO>,
  dialogFormVisible: false,
  editMode: false,
  form: {
    riskModuleKriId: '',
    riskModuleId: '',
    type: '',
    page: 1,
    size: 10,
  } as KriMetricsSettingSearchVO,
  total: 0,
});

const ruleForm = {
  name: [{ required: true, message: '请填写名称', trigger: 'blur' }],
  type: [{ required: true, message: '请选择类型', trigger: 'change' }],
  riskModuleId: [{ required: true, message: '请选择模块', trigger: 'change' }],
  riskModuleKriId: [{ required: true, message: '请选择kri', trigger: 'blur' }],
  weight: [{ required: true, message: '请填写权重', trigger: 'blur' }],
  collectColumn: [
    { required: true, message: '请填写采集列名', trigger: 'blur' },
  ],
};

const obtainPocket = (pocketName: string) =>
  stubs.pockets.obtainPocket(pocketName);

const kri = computed(() =>
  obtainPocket('kri').filter(
    (it) => it.extra.moduleId === state.form.riskModuleId
  )
);

const formKri = computed(() =>
  obtainPocket('kri').filter(
    (it) => it.extra.moduleId === state.editItem.riskModuleId
  )
);

const transformRiskRateSetting = (obj: RiskRatingSettingObj) => {
  if (obj) {
    return `[${proxy.pocketLabel('levelRangeSymbol', obj.symbol1) || ''},${
      obj.value1 || '-'
    },${proxy.pocketLabel('levelRangeSymbol', obj.symbol2) || ''},${
      obj.value2 || '-'
    }]`;
  }
};

const search = async (page?: number) => {
  if (page) {
    state.form.page = page;
  }
  const res = await controller.search(state.form);
  state.data = res.result.map((it) => ({ ...it, weight: it.weight * 100 }));
  state.total = res.totalElements || 0;
};

const reset = async () => {
  state.form = { page: 1, size: 10 };
  search(1);
};

const multiple100 = (num: number | null | undefined) => {
  if (typeof num === 'number') return num + '%';
  return num;
};

const addOrEdit = (
  item = {
    valueDisplayMode: 'DEFAULT',
    setting: Object.fromEntries(
      [1, 2, 3, 4, 5].map((key) => [
        key,
        {
          symbol1: 'moreThanOrEquals',
          symbol2: 'lessThanOrEquals',
          value1: 0,
          value2: 0,
        },
      ])
    ) as any,
  } as KriMetricsSettingVO
) => {
  state.editMode = item?.id?.length > 0;
  state.editItem = { ...item };
  state.dialogFormVisible = true;
};

const enableOrDisable =async (
  kriMetrics: KriMetricsSettingVO,
  disabled: Boolean
) => {
  var param = {...kriMetrics}
  param.disabled = disabled;
  await controller.upset(param);
  ElMessage.success('操作成功!');
  await search();
};

const download = async () => {
  await controller.download(state.form);
};

const confirm = async (item: KriMetricsSettingVO) => {
  item.weight = item.weight / 100;
  await controller.upset(item);
  ElMessage.success('创建/修改成功!');
  state.dialogFormVisible = false;
  search();
};

search();

return (_ctx: any,_cache: any) => {
  const _component_simple_select = _resolveComponent("simple-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_mas_form_main = _resolveComponent("mas-form-main")!
  const _component_wapper = _resolveComponent("wapper")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_simple_input = _resolveComponent("simple-input")!
  const _component_risk_rating_form = _resolveComponent("risk-rating-form")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_simple_table_column = _resolveComponent("simple-table-column")!
  const _component_simple_confirm_button = _resolveComponent("simple-confirm-button")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_wapper, null, {
      default: _withCtx(() => [
        _createVNode(_component_mas_form_main, {
          inline: true,
          form: _unref(state).form,
          defaultFormFooterButton: ['confirm', 'reset'],
          defaultFormFooterConfirmText: "搜索",
          "label-width": "120px",
          onConfim: _cache[4] || (_cache[4] = ($event: any) => (search(1))),
          onReset: reset
        }, {
          content: _withCtx(() => [
            _createVNode(_component_el_form_item, { label: "模块" }, {
              default: _withCtx(() => [
                _createVNode(_component_simple_select, {
                  options: _ctx.pocket('module'),
                  style: {"width":"240px"},
                  clearable: "",
                  modelValue: _unref(state).form.riskModuleId,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(state).form.riskModuleId) = $event)),
                  onChange: _cache[1] || (_cache[1] = ($event: any) => (_unref(state).form.riskModuleKriId = ''))
                }, null, 8, ["options", "modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "kri" }, {
              default: _withCtx(() => [
                _createVNode(_component_simple_select, {
                  options: _unref(kri),
                  clearable: "",
                  style: {"width":"240px"},
                  modelValue: _unref(state).form.riskModuleKriId,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(state).form.riskModuleKriId) = $event))
                }, null, 8, ["options", "modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "类型" }, {
              default: _withCtx(() => [
                _createVNode(_component_simple_select, {
                  options: _ctx.pocket('riskType'),
                  clearable: "",
                  style: {"width":"240px"},
                  modelValue: _unref(state).form.type,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(state).form.type) = $event))
                }, null, 8, ["options", "modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["form"])
      ]),
      _: 1
    }),
    _createVNode(_component_wapper, null, {
      default: _withCtx(() => [
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_component_el_button, {
              type: "primary",
              onClick: _cache[5] || (_cache[5] = ($event: any) => (addOrEdit()))
            }, {
              default: _withCtx(() => [
                _hoisted_2
              ]),
              _: 1
            }),
            _createVNode(_component_el_button, {
              type: "primary",
              onClick: _cache[6] || (_cache[6] = ($event: any) => (download()))
            }, {
              default: _withCtx(() => [
                _hoisted_3
              ]),
              _: 1
            }),
            _createVNode(_component_el_dialog, {
              modelValue: _unref(state).dialogFormVisible,
              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_unref(state).dialogFormVisible) = $event)),
              title: _unref(state).editMode ? '编辑' : '新增',
              width: "600"
            }, {
              footer: _withCtx(() => [
                _createElementVNode("div", _hoisted_5, [
                  _createVNode(_component_el_button, {
                    onClick: _cache[8] || (_cache[8] = ($event: any) => (_unref(state).dialogFormVisible = false))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_6
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_button, {
                    type: "primary",
                    onClick: _cache[9] || (_cache[9] = ($event: any) => ((_ctx.$refs.masForm as any).confirm()))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_7
                    ]),
                    _: 1
                  })
                ])
              ]),
              default: _withCtx(() => [
                (_openBlock(), _createBlock(_component_mas_form_main, {
                  ref: "masForm",
                  form: _unref(state).editItem,
                  defaultFormFooterButton: [],
                  ruleForm: ruleForm,
                  "label-width": "120px",
                  key: _unref(state).dialogFormVisible,
                  onConfim: confirm
                }, {
                  content: _withCtx((slotProps) => [
                    _createVNode(_component_el_form_item, {
                      label: "名称",
                      prop: "name"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          style: {"width":"240px"},
                          modelValue: slotProps.content.name,
                          "onUpdate:modelValue": ($event: any) => ((slotProps.content.name) = $event)
                        }, null, 8, ["modelValue", "onUpdate:modelValue"])
                      ]),
                      _: 2
                    }, 1024),
                    _createVNode(_component_el_form_item, {
                      label: "模块",
                      prop: "riskModuleId"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_simple_select, {
                          options: _ctx.pocket('module'),
                          style: {"width":"240px"},
                          disabled: _unref(state).editMode,
                          modelValue: slotProps.content.riskModuleId,
                          "onUpdate:modelValue": ($event: any) => ((slotProps.content.riskModuleId) = $event),
                          onChange: _cache[7] || (_cache[7] = ($event: any) => (_unref(state).editItem.riskModuleKriId = ''))
                        }, null, 8, ["options", "disabled", "modelValue", "onUpdate:modelValue"])
                      ]),
                      _: 2
                    }, 1024),
                    _createVNode(_component_el_form_item, {
                      label: "类型",
                      prop: "type"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_simple_select, {
                          options: _ctx.pocket('riskType'),
                          style: {"width":"240px"},
                          disabled: _unref(state).editMode,
                          modelValue: slotProps.content.type,
                          "onUpdate:modelValue": ($event: any) => ((slotProps.content.type) = $event)
                        }, null, 8, ["options", "disabled", "modelValue", "onUpdate:modelValue"])
                      ]),
                      _: 2
                    }, 1024),
                    _createVNode(_component_el_form_item, {
                      label: "kri",
                      prop: "riskModuleKriId"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_simple_select, {
                          options: _unref(formKri),
                          style: {"width":"240px"},
                          disabled: _unref(state).editMode,
                          modelValue: slotProps.content.riskModuleKriId,
                          "onUpdate:modelValue": ($event: any) => ((slotProps.content.riskModuleKriId) = $event)
                        }, null, 8, ["options", "disabled", "modelValue", "onUpdate:modelValue"])
                      ]),
                      _: 2
                    }, 1024),
                    _createVNode(_component_el_form_item, {
                      label: "权重",
                      prop: "weight"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_simple_input, {
                          style: {"width":"240px"},
                          modelValue: slotProps.content.weight,
                          "onUpdate:modelValue": ($event: any) => ((slotProps.content.weight) = $event)
                        }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                        _hoisted_4
                      ]),
                      _: 2
                    }, 1024),
                    _createVNode(_component_el_form_item, { label: "值显示方式" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_simple_select, {
                          options: _ctx.pocket('kriMetricsValueDisplayMode'),
                          style: {"width":"240px"},
                          modelValue: slotProps.content.valueDisplayMode,
                          "onUpdate:modelValue": ($event: any) => ((slotProps.content.valueDisplayMode) = $event)
                        }, null, 8, ["options", "modelValue", "onUpdate:modelValue"])
                      ]),
                      _: 2
                    }, 1024),
                    _createVNode(_component_el_form_item, {
                      label: "采集列名",
                      prop: "collectColumn"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          style: {"width":"240px"},
                          modelValue: slotProps.content.collectColumn,
                          "onUpdate:modelValue": ($event: any) => ((slotProps.content.collectColumn) = $event)
                        }, null, 8, ["modelValue", "onUpdate:modelValue"])
                      ]),
                      _: 2
                    }, 1024),
                    (slotProps.content.type === 'NORMAL')
                      ? (_openBlock(), _createBlock(_component_el_form_item, {
                          key: 0,
                          label: "定级设置",
                          prop: "setting"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_risk_rating_form, {
                              modelValue: slotProps.content.setting,
                              "onUpdate:modelValue": ($event: any) => ((slotProps.content.setting) = $event)
                            }, null, 8, ["modelValue", "onUpdate:modelValue"])
                          ]),
                          _: 2
                        }, 1024))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }, 8, ["form"]))
              ]),
              _: 1
            }, 8, ["modelValue", "title"])
          ]),
          _createVNode(_component_el_table, {
            class: "common-table",
            data: _unref(state).data,
            border: ""
          }, {
            default: _withCtx(() => [
              _createVNode(_component_simple_table_column, {
                label: "名称",
                prop: "name"
              }),
              _createVNode(_component_simple_table_column, {
                label: "类型",
                prop: "type",
                pocketName: "riskType"
              }),
              _createVNode(_component_simple_table_column, {
                label: "模块",
                prop: "riskModuleId",
                pocketName: "module"
              }),
              _createVNode(_component_simple_table_column, {
                label: "KRI",
                prop: "riskModuleKriId",
                pocketName: "kri"
              }),
              _createVNode(_component_simple_table_column, { label: "定级" }, {
                default: _withCtx(({ row }) => [
                  (_openBlock(), _createElementBlock(_Fragment, null, _renderList(['1', '2', '3', '4', '5'], (key) => {
                    return _createElementVNode("div", null, _toDisplayString(key) + "级： " + _toDisplayString(transformRiskRateSetting(row.setting[key])), 1)
                  }), 64))
                ]),
                _: 1
              }),
              _createVNode(_component_simple_table_column, {
                label: "权重",
                formatter: (row) => multiple100(row.weight)
              }, null, 8, ["formatter"]),
              _createVNode(_component_simple_table_column, {
                label: "值显示方式",
                prop: "valueDisplayMode",
                "pocket-name": "kriMetricsValueDisplayMode"
              }),
              _createVNode(_component_simple_table_column, { label: "状态" }, {
                default: _withCtx(({ row }: { row: KriMetricsSettingVO }) => [
                  _createTextVNode(_toDisplayString(row.disabled? '停用' : '启用'), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_simple_table_column, { label: "操作" }, {
                default: _withCtx(({ row }: { row: KriMetricsSettingVO }) => [
                  (row.disabled)
                    ? (_openBlock(), _createBlock(_component_simple_confirm_button, {
                        key: 0,
                        title: "确认要启用该kri指标吗？",
                        onClick: ($event: any) => (enableOrDisable(row, 0))
                      }, {
                        default: _withCtx(() => [
                          _hoisted_8
                        ]),
                        _: 2
                      }, 1032, ["onClick"]))
                    : _createCommentVNode("", true),
                  (!row.disabled)
                    ? (_openBlock(), _createBlock(_component_simple_confirm_button, {
                        key: 1,
                        title: "确认要停用该kri指标吗？",
                        onClick: ($event: any) => (enableOrDisable(row, 1))
                      }, {
                        default: _withCtx(() => [
                          _hoisted_9
                        ]),
                        _: 2
                      }, 1032, ["onClick"]))
                    : _createCommentVNode("", true),
                  _createVNode(_component_el_button, {
                    type: "text",
                    onClick: ($event: any) => (addOrEdit(row))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_10
                    ]),
                    _: 2
                  }, 1032, ["onClick"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["data"]),
          _createElementVNode("div", _hoisted_11, [
            _createVNode(_component_el_pagination, {
              total: _unref(state).total,
              "current-page": _unref(state).form.page,
              "page-size": _unref(state).form.size,
              onCurrentChange: search,
              layout: "total, prev, pager, next, jumper"
            }, null, 8, ["total", "current-page", "page-size"])
          ])
        ])
      ]),
      _: 1
    })
  ]))
}
}

})